<template>
<div>
    <div class="sm:flex flex-wrap mb-4 w-screen">
        <!-- Left Half Desktop -->
        <div class="md:w-1/2 text-center">
            <!-- Top Mobile -->
        <HeroTitle
        :result="results[heroNumber].title"
        :class="titleclass"
        />
        <span class="mt-4 relative h-12 block mr-20 sm:mr-0 overflow-hidden">
        <img
        style="max-width:none"
        :src="stripes"
        class="sm:hidden block absolute left-0 top-0 max-w-none w-screen"
        />
        <img
        :src="stripes"
        class="hidden sm:block absolute left-0 top-0 max-w-none w-screen"
        />
        </span>
        <!-- Result Character Mobile Toggle -->

        <img
        :src="require('@/assets/img/SVG/'+results[heroNumber].img)"
        class="p-6 block md:hidden"
        />
            <!-- Bottom Mobile -->
        <div class="lg:w-8/12 text-md lg:ml-40 text-left lg:mt-8 m-3">
        <b class="bg-black text-white py-1 px-1"> About: {{results[heroNumber].title}} </b>
        <AboutTextBox
        :text="results[heroNumber].description"
        :class="aboutclass"
        />
        <div class="text-md text-left mt-2 lg:mt-2">
        <b class="bg-black text-white py-1 px-1"> Watch Out: </b>
        <AboutTextBox
        :text="results[heroNumber].watchout"
        :class="aboutclass"
        />
        </div>
        <div>
        <div class="flex justify-center mt-4">
        <button
        class="p-3 bg-heroyellow"
        @click="toggleHeroBack"
        >
          <i class="fas fa-chevron-left"></i>
        </button>
        <button
        class="p-3 bg-herored"
        @click="toggleHeroPlus"
        >
          <i class="fas fa-chevron-right"></i>
        </button>
        </div>
        </div>
        </div>
        </div>
        <!-- Right Half Desktop -->
        <div class="sm:w-1/2 relative text-center">
          <span class="center-object right-0 w-full absolute p-12">
          <img
          @NextAnimation="nextAnimation = $event"
          :src="require('@/assets/img/SVG/'+results[heroNumber].img)"
          class="hidden m-8 md:block animated fadeIn"
          />
        </span>
        </div>
  </div>
</div>
</template>

<script>
import HeroTitle from "@/components/content/title/HeroTitle.vue"
import AboutTextBox from "@/components/content/textbox/AboutTextBox.vue"

export default {
    components: {
        HeroTitle,
        AboutTextBox
    },
    data() {
        return {
            titleclass: "ml-2 lg:ml-40 lg:mt-40 text-left leading-none font-semibold",
            aboutclass: "mt-2",
            stripes: require("@/assets/img/SVG/stripes.svg"),
            results: require("@/data/result/result.json"),
            heroNumber: 0,
        }
    },
    methods: {
      toggleHeroPlus() {
        var vm = this
        this.heroNumber ++
        if (this.heroNumber > 8) {
          this.heroNumber = 0
        }
        vm.$emit('NextAnimation', 'animated fadeIn fast');
      },
      toggleHeroBack() {
        this.heroNumber --
        if (this.heroNumber < 0) {
          this.heroNumber = 8
        }
      }
    }
}
</script>
